import { Entity } from '../Entity';
import { SupplierCreditNoteMappingType } from '../../../enums';

export interface SupplierCreditNoteItemMapping extends Entity {
  client?: string;
  clientName?: string;
  supplierCreditNoteItem?: string;
  supplierInvoice?: string | null;
  supplierInvoiceItem?: string | null;
  clientInvoice?: string | null;
  clientInvoiceItem?: string | null;
  clientCreditNoteItem?: string;
  clientCreditNoteDraftItem?: string;
}

export interface StoredSupplierCreditNoteItemLink {
  documentType: SupplierCreditNoteMappingType;
  documentIri: string;
  itemType?: SupplierCreditNoteMappingType;
  itemIri?: string;
}

export const linkTypeMap: Record<SupplierCreditNoteMappingType, any> = {
  [SupplierCreditNoteMappingType.SUPPLIER_INVOICE]: {
    documentLink: {
      label: 'SUPPLIER_INVOICE',
      icon: 'rc-icon-sales-invoice',
      type: SupplierCreditNoteMappingType.SUPPLIER_INVOICE
    }
  },
  [SupplierCreditNoteMappingType.SUPPLIER_INVOICE_ITEM]: {
    documentLink: {
      label: 'SUPPLIER_INVOICE',
      icon: 'rc-icon-purchase-invoice',
      type: SupplierCreditNoteMappingType.SUPPLIER_INVOICE
    },
    itemLink: {
      label: 'SUPPLIER_INVOICE_LINE',
      icon: 'rc-icon-purchase-invoice-lines',
      type: SupplierCreditNoteMappingType.SUPPLIER_INVOICE_ITEM
    }
  },
  [SupplierCreditNoteMappingType.CLIENT_INVOICE]: {
    documentLink: {
      label: 'CLIENT_INVOICE',
      icon: 'rc-icon-sales-invoice',
      type: SupplierCreditNoteMappingType.CLIENT_INVOICE
    }
  },
  [SupplierCreditNoteMappingType.CLIENT_INVOICE_ITEM]: {
    documentLink: {
      label: 'CLIENT_INVOICE',
      icon: 'rc-icon-sales-invoice',
      type: SupplierCreditNoteMappingType.CLIENT_INVOICE
    },
    itemLink: {
      label: 'CLIENT_INVOICE_LINE',
      icon: 'rc-icon-sales-invoice-lines',
      type: SupplierCreditNoteMappingType.CLIENT_INVOICE_ITEM
    }
  },
  [SupplierCreditNoteMappingType.CLIENT_CREDIT_NOTE]: {
    documentLink: {
      label: 'CLIENT_CREDIT_NOTE',
      icon: 'rc-icon-credit-note',
      type: SupplierCreditNoteMappingType.CLIENT_CREDIT_NOTE
    }
  }
};
